import ShippingRatesEdit from "./ShippingRatesEdit";

const shippingRates = {
  edit: ShippingRatesEdit,
};

export default shippingRates;